<template>

<div>

    <alert :alert="alert"></alert>

    <form>

        <!--테스트 회원-->
        <div v-if="user_type === 'tester'">

            <!--로그인 아이디 (생성모드)-->
            <div class="form-group"
                 v-if="mode === 'create'"
                 v-bind:class="{'has-error has-feedback': errors.has('login_id')}">

                <label v-bind:class="{'control-label': errors.has('login_id')}">로그인 아이디</label>
                <p class="text-info">아이디로 입력하신 이메일로 인증과정이 진행됩니다.</p>
                <input name="login_id" type="text" class="form-control" placeholder="이메일 형식의 아이디를 입력하세요."
                       data-vv-as="'로그인 아이디'" data-vv-delay="500"
                       v-model="data.mb_id"
                       v-validate="'required|email|unique_id'">
                <span class="text-danger"
                      v-show="errors.has('login_id')">{{ errors.first('login_id') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('login_id')"></span>
            </div>

            <!--로그인 아이디 (수정모드)-->
            <div class="form-group"
                 v-if="mode === 'modify'">

                <label v-bind:class="{'control-label': errors.has('login_id')}">로그인 아이디</label>
                <input name="login_id" type="text" class="form-control" readonly
                       v-model="data.mb_id">
            </div>

            <!--비밀번호-->
            <div class="form-group"
                 v-if="mode === 'create'"
                 v-bind:class="{'has-error has-feedback': errors.has('password')}">

                <label v-bind:class="{'control-label': errors.has('password')}">비밀번호</label>
                <input name="password" type="password" class="form-control" placeholder="영문, 숫자, 특수기호(!, @, #, $, %, ^, &, *, -, _, +, =, ?)만 가능합니다." data-vv-as="'비밀번호'"
                       v-model="data.mb_password"
                       v-validate="'required|min:8|max:16|regex:^([0-9a-zA-Z!@#$%^&*-_+=?]+)$'">
                <span class="text-danger"
                      v-show="errors.has('password')">{{ errors.first('password') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('password')"></span>
            </div>

            <!--비밀번호 확인-->
            <div class="form-group"
                 v-if="mode === 'create'"
                 v-bind:class="{'has-error has-feedback': errors.has('password-confirm')}">

                <label v-bind:class="{'control-label': errors.has('password-confirm')}">비밀번호 확인</label>
                <input name="password-confirm" type="password" class="form-control" placeholder="" data-vv-as="'비밀번호 확인'"
                       v-validate="'confirmed:password'">
                <span class="text-danger"
                      v-show="errors.has('password-confirm')">{{ errors.first('password-confirm') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('password-confirm')"></span>
            </div>

            <!--이름-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('name')}">

                <label v-bind:class="{'control-label': errors.has('name')}">이름</label>
                <input name="name" type="text" class="form-control" placeholder="" data-vv-as="'이름'"
                       v-model="data.mb_name"
                       v-validate="{ required: true, regex: /^[가-힣0-9]+$/, max: 10 }">
                <span class="text-danger"
                      v-show="errors.has('name')">{{ errors.first('name') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('name')"></span>
            </div>

            <!--성별-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('gender')}">
                <label v-bind:class="{'control-label': errors.has('gender')}">성별</label>

                <div>
                    <label class="radio-inline">
                        <input type="radio" name="gender" value="m" v-validate="'required'" v-model="data.mb_sex" data-vv-as="'성별'"> 남성
                    </label>
                    <label class="radio-inline">
                        <input type="radio" name="gender" value="f" v-model="data.mb_sex"> 여성
                    </label>
                </div>
                <span class="text-danger"
                      v-show="errors.has('gender')">{{ errors.first('gender') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('gender')"></span>
            </div>

            <!--생년월일-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('birthday')}">
                <label v-bind:class="{'control-label': errors.has('birthday')}">생년월일</label>

                <input name="birthday" type="hidden" class="form-control" data-vv-as="'생년월일'"
                       v-model="startTime.time"
                       v-validate="'required|beforeDate:' + this.birthdayBefore()">
                <date-picker :date="startTime" :option="date_picker_option"></date-picker>
                <span class="text-danger"
                      v-show="errors.has('birthday')">{{ errors.first('birthday') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('birthday')"></span>
            </div>

            <!--연락처-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('tel')}">

                <label v-bind:class="{'control-label': errors.has('tel')}">연락처</label>
                <input name="tel" type="tel" class="form-control" placeholder="" data-vv-as="'연락처'"
                       v-model="data.mb_tel"
                       v-validate="'required|numeric|min:7|max:20'">
                <span class="text-danger"
                      v-show="errors.has('tel')">{{ errors.first('tel') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('tel')"></span>
            </div>

            <!--주소-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('address')}">

                <label v-bind:class="{'control-label': errors.has('address')}">주소</label>
                <input name="address" type="hidden" v-model="data.address.data.zonecode" v-validate="'required'" data-vv-as="'주소'">
                <daum-postcode v-bind:postcode="data.address"></daum-postcode>
                <span class="text-danger"
                      v-show="errors.has('tel')">{{ errors.first('address') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('address')"></span>
            </div>

            <!--테스트 경험 여부-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('testing_experience')}">
                <label v-bind:class="{'control-label': errors.has('testing_experience')}">테스트 경험 여부</label>

                <div>
                    <label class="radio-inline">
                        <input type="radio" name="testing_experience" value="true" v-validate="'required'"
                               v-model="data.mb_testing_experience"
                               data-vv-as="'테스트 경험 여부'"> 있음
                    </label>
                    <label class="radio-inline">
                        <input type="radio" name="testing_experience" value="false" v-model="data.mb_testing_experience"> 없음
                    </label>
                </div>
                <span class="text-danger"
                      v-show="errors.has('testing_experience')">{{ errors.first('testing_experience') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('testing_experience')"></span>
            </div>

            <!--IT 관련 자격증-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('it_certificate')}">

                <label v-bind:class="{'control-label': errors.has('it_certificate')}">IT 관련 자격증 및 관련 경력</label>
                <textarea name="it_certificate"  class="form-control"
                          placeholder="* IT 관련 자격증: (자격증 명칭)
* 관련 경력: 00년"
                          data-vv-as="'IT 관련 자격증'"
                          v-model="data.mb_it_certificate"
                          v-validate="''">
                </textarea>
                <span class="text-danger"
                      v-show="errors.has('it_certificate')">{{ errors.first('it_certificate') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('it_certificate')"></span>
            </div>

            <!--전문 테스터 신청-->
            <div class="form-group"
                 v-if="mode == 'create'"
                 v-bind:class="{'has-error has-feedback': errors.has('expert_tester_request')}">
                <label v-bind:class="{'control-label': errors.has('expert_tester_request')}">전문 테스터 신청</label>
                <p class="text-info">전문테스터는 관련 자료 확인 후 심사하여 결정됩니다.</p>
                <div>
                    <label class="radio-inline">
                        <input type="radio" name="expert_tester_request" value="true" v-validate="'required'"
                               v-model="data.expert_tester_request"
                               data-vv-as="'테스트 경험 여부'"> 신청
                    </label>
                    <label class="radio-inline">
                        <input type="radio" name="expert_tester_request" value="false" v-model="data.expert_tester_request"> 미신청
                    </label>
                </div>
                <span class="text-danger"
                      v-show="errors.has('expert_tester_request')">{{ errors.first('expert_tester_request') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('expert_tester_request')"></span>
            </div>

            <div class="" v-if="mode == 'modify'">
                <label>테스터 유형</label>
                <p v-text="data.mb_tester_type == 'normal' ? '일반테스터' : '전문테스터'"></p>
                <div class="mt-4">
                    <button v-if="data.mb_tester_type == 'normal'"
                            :disabled="data.expert_request_status == 'pending'"
                            @click.prevent="requestExpertTest"
                            v-text="requestExpertTesterBtnText"
                            class="btn btn-default btn-block">
                    </button>
                </div>
            </div>

        </div>

        <!--기업 회원-->
        <div v-else-if="user_type === 'company'">

            <!--로그인 아이디 (생성모드)-->
            <div class="form-group"
                 v-if="mode === 'create'"
                 v-bind:class="{'has-error has-feedback': errors.has('login_id')}">

                <label v-bind:class="{'control-label': errors.has('login_id')}">로그인 아이디</label>
                <p class="text-info">아이디로 입력하신 이메일로 인증과정이 진행됩니다.</p>
                <input name="login_id" type="text" class="form-control" placeholder="이메일 형식의 아이디를 입력하세요."
                       data-vv-as="'로그인 아이디'" data-vv-delay="500"
                       v-model="data.mb_id"
                       v-validate="'required|email|unique_id'">
                <span class="text-danger"
                      v-show="errors.has('login_id')">{{ errors.first('login_id') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('login_id')"></span>
            </div>

            <!--로그인 아이디 (수정모드)-->
            <div class="form-group"
                 v-if="mode === 'modify'">

                <label v-bind:class="{'control-label': errors.has('login_id')}">로그인 아이디</label>
                <input name="login_id" type="text" class="form-control" readonly
                       v-model="data.mb_id">
            </div>

            <!--비밀번호-->
            <div class="form-group"
                 v-if="mode === 'create'"
                 v-bind:class="{'has-error has-feedback': errors.has('password')}">

                <label v-bind:class="{'control-label': errors.has('password')}">비밀번호</label>
                <input name="password" type="password" class="form-control" placeholder="영문, 숫자, 특수기호(!, @, #, $, %, ^, &, *, -, _, +, =, ?)만 가능합니다." data-vv-as="'비밀번호'"
                       v-model="data.mb_password"
                       v-validate="'required|min:8|max:16|regex:^([0-9a-zA-Z!@#$%^&*-_+=?]+)$'">
                <span class="text-danger"
                      v-show="errors.has('password')">{{ errors.first('password') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('password')"></span>
            </div>

            <!--비밀번호 확인-->
            <div class="form-group"
                 v-if="mode === 'create'"
                 v-bind:class="{'has-error has-feedback': errors.has('password-confirm')}">

                <label v-bind:class="{'control-label': errors.has('password-confirm')}">비밀번호 확인</label>
                <input name="password-confirm" type="password" class="form-control" placeholder="" data-vv-as="'비밀번호 확인'"
                       v-validate="'confirmed:password'">
                <span class="text-danger"
                      v-show="errors.has('password-confirm')">{{ errors.first('password-confirm') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('password-confirm')"></span>
            </div>

            <!--기업명-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('name')}">

                <label v-bind:class="{'control-label': errors.has('name')}">기업명</label>
                <input name="name" type="text" class="form-control" placeholder="" data-vv-as="'기업명'"
                       v-model="data.mb_name"
                       v-validate="{ required: true, max: 20 }">
                <span class="text-danger"
                      v-show="errors.has('name')">{{ errors.first('name') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('name')"></span>
            </div>

            <!--기업 대표 이메일-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('email')}">

                <label v-bind:class="{'control-label': errors.has('email')}">대표 이메일</label>
                <input name="email" type="email" class="form-control" placeholder="" data-vv-as="'대표 이메일'"
                       v-model="data.mb_email"
                       v-validate="'required|email'">
                <span class="text-danger"
                      v-show="errors.has('email')">{{ errors.first('email') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('email')"></span>
            </div>

            <!--기업 대표 연락처-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('tel')}">

                <label v-bind:class="{'control-label': errors.has('tel')}">대표 연락처</label>
                <input name="tel" type="tel" class="form-control" placeholder="" data-vv-as="'대표 연락처'"
                       v-model="data.mb_tel"
                       v-validate="'required|numeric|min:7|max:20'">
                <span class="text-danger"
                      v-show="errors.has('tel')">{{ errors.first('tel') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('tel')"></span>
            </div>

            <!--주소-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('address')}">

                <label v-bind:class="{'control-label': errors.has('address')}">주소</label>
                <input name="address" type="hidden" v-model="data.address.data.zonecode" v-validate="'required'" data-vv-as="'주소'">
                <daum-postcode v-bind:postcode="data.address"></daum-postcode>
                <span class="text-danger"
                      v-show="errors.has('tel')">{{ errors.first('address') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('address')"></span>
            </div>

            <!--담당자 이름-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('staff_name')}">

                <label v-bind:class="{'control-label': errors.has('staff_name')}">담당자 이름</label>
                <input name="staff_name" type="text" class="form-control" placeholder="" data-vv-as="'담당자 이름'"
                       v-model="data.mb_staff_name"
                       v-validate="{ required: true, regex: /^[가-힣]+$/, max: 10 }">
                <span class="text-danger"
                      v-show="errors.has('staff_name')">{{ errors.first('staff_name') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('staff_name')"></span>
            </div>

            <!--담당자 연락처-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('staff_tel')}">

                <label v-bind:class="{'control-label': errors.has('staff_tel')}">담당자 연락처</label>
                <input name="staff_tel" type="tel" class="form-control" placeholder="" data-vv-as="'담당자 연락처'"
                       v-model="data.mb_staff_tel"
                       v-validate="'required|numeric|min:7|max:20'">
                <span class="text-danger"
                      v-show="errors.has('staff_tel')">{{ errors.first('staff_tel') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('staff_tel')"></span>
            </div>

            <!--담당자 이메일-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('staff_email')}">

                <label v-bind:class="{'control-label': errors.has('staff_email')}">담당자 이메일</label>
                <input name="staff_email" type="email" class="form-control" placeholder="" data-vv-as="'담당자 이메일'"
                       v-model="data.mb_staff_email"
                       v-validate="'required|email'">
                <span class="text-danger"
                      v-show="errors.has('staff_email')">{{ errors.first('staff_email') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('staff_email')"></span>
            </div>

            <!--사업자 종류-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('business_type')}">
                <label v-bind:class="{'control-label': errors.has('business_type')}">사업자 종류</label>

                <div>
                    <label class="radio-inline">
                        <input type="radio" name="business_type" value="individual"
                               data-vv-as="'사업자 종류'"
                               v-model="data.mb_business_type"
                               v-validate="'required'"> 개인
                    </label>
                    <label class="radio-inline">
                        <input type="radio" name="business_type" value="corporate" v-model="data.mb_business_type" > 법인
                    </label>
                </div>
                <span class="text-danger"
                      v-show="errors.has('business_type')">{{ errors.first('business_type') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('business_type')"></span>
            </div>

            <!--사업자 번호-->
            <div class="form-group"
                 v-bind:class="{'has-error has-feedback': errors.has('business_number')}">

                <label v-bind:class="{'control-label': errors.has('business_number')}">사업자 번호</label>
                <input name="business_number" type="tel" class="form-control" placeholder=""
                       data-vv-as="'사업자 번호'"
                       v-model="data.mb_business_number"
                       v-validate="'required|numeric|min:10|max:20'">
                <span class="text-danger"
                      v-show="errors.has('business_number')">{{ errors.first('business_number') }}</span>
                <span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"
                      v-show="errors.has('business_number')"></span>
            </div>

        </div>

        <hr>

        <button type="submit" class="btn btn-default btn-block btn-submit btn-custom"
                v-text="mode == 'create' ? '회원가입' : '정보수정'"
                @click.prevent="validateBeforeSubmit"></button>

        <button type="button" class="btn btn-danger btn-block" v-if="mode == 'modify'" @click.prevent="withdrawalFromSite">회원탈퇴</button>

    </form>
</div>

</template>

<script>

    import $ from 'jquery'
    import Datepicker from 'vue-datepicker'
    import DaumPostcode from './DaumPostcode'
    import Alert from './Alert';
    import moment from 'moment';

    export default {
        name: "user",
        props: ['userId', 'userType'],
        components: {
            'date-picker': Datepicker,
            'daum-postcode': DaumPostcode
        },
        data() {
            return {
                user_id: '',
                user_type: '',
                data: {
                    mb_no: '',      // 식별값
                    mb_id: '',      // 로그인 아이디
                    mb_password: '',// 비밀번호
                    mb_name: '',    // 이름, 기업명
                    mb_email: '',   // 이메일, 대표 이메일
                    mb_sex: '',     // 성별
                    mb_tel: '',     // 연락처, 대표 연락처
                    mb_staff_name: '',  // 담당자 이름
                    mb_staff_tel: '',   // 담당자 연락처
                    mb_staff_email: '', // 담당자 이메일
                    mb_business_type: '',   // 사업자 종류
                    mb_business_number: '', // 사업자 번호
                    mb_testing_experience: false,  // 테스트 경험 여부
                    mb_it_certificate: '',      // IT 관련 자격증
                    mb_tester_type: "",
                    expert_request_status: "",
                    address: {
                        extraAddress: '',
                        data: {}
                    },
                    expert_tester_request: false
                },
                startTime: {
                    time: ''
                },
                date_picker_option: {
                    type: 'day',
                    week: ['월', '화', '수', '목', '금', '토', '일'],
                    month: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                    format: 'YYYY-MM-DD',
                    placeholder: '날짜를 선택하세요.',
                    buttons: {
                        ok: '확인',
                        cancel: '취소'
                    },
                },
                alert: {
                    type: 'info',
                    is_open: false,
                    title: '알려드립니다.',
                    body: '',
                }
            }
        },
        created() {

            if (this.userType === 'tester' || this.userType === 'company') {
                this.user_type = this.userType;
            } else {
                // 오류발생
            }

            this.user_id = this.userId;

            if (this.user_id) {
                this.loadUser();
            }

        },
        computed: {
            user() {
                var $this = this;

                return {
                    mb_no: $this.data.mb_no,      // 식별값
                    mb_id: $this.data.mb_id,      // 로그인 아이디
                    mb_password: $this.data.mb_password,// 비밀번호
                    mb_name: $this.data.mb_name,    // 이름, 기업명
                    mb_email: $this.data.mb_email,   // 이메일, 대표 이메일
                    mb_sex: $this.data.mb_sex,     // 성별
                    mb_birth: $this.startTime.time,   // 생년월일 (startTime 에서 데이터를 가지고 와야 됨)
                    mb_tel: $this.data.mb_tel,     // 연락처, 대표 연락처
                    mb_staff_name: $this.data.mb_staff_name,  // 담당자 이름
                    mb_staff_tel: $this.data.mb_staff_tel,   // 담당자 연락처
                    mb_staff_email: $this.data.mb_staff_email, // 담당자 이메일
                    mb_business_type: $this.data.mb_business_type,   // 사업자 종류
                    mb_business_number: $this.data.mb_business_number, // 사업자 번호
                    mb_testing_experience: $this.data.mb_testing_experience,  // 테스트 경험 여부
                    mb_it_certificate: $this.data.mb_it_certificate,      // IT 관련 자격증
                    mb_zip1: $this.data.address.data.zonecode.substr(0,3),
                    mb_zip2: $this.data.address.data.zonecode.substr(3),
                    mb_addr1: $this.data.address.data.sido,
                    mb_addr2: $this.data.address.data.sigungu,
                    mb_addr3: $this.data.address.data.bname,
                    mb_addr_extra: $this.data.address.extraAddress,
                    mb_addr_jibeon: $this.data.address.data.jibunAddress,
                    mb_addr_road: $this.data.address.data.roadAddress,
                    mb_type: $this.user_type,
                    expert_tester_request: $this.data.expert_tester_request
                }
            },
            mode() {
                if (this.user_id != '') {
                    return 'modify'
                } else {
                    return 'create'
                }
            },
            requestExpertTesterBtnText() {
                if (this.data.expert_request_status === null) {
                    return "전문테스터 신청하기"
                } else if (this.data.expert_request_status == "pending") {
                    return "전문테스터 신청이 접수되었습니다."
                } else if (this.data.expert_request_status == "fail") {
                    return "전문테스터로 선정되지 못했습니다. 다시 요청하시겠습니까?"
                }
            }
        },
        methods: {
            loadUser() {
                var $this = this;
                $.ajax({
                    method: "GET",
                    url: "/ajax/user/" + $this.user_id,
                })
                .done((response) => {

                    $this.user_type = response.mb_type;

                    $this.data.mb_no = response.mb_no;
                    $this.data.mb_id = response.mb_id;
                    $this.data.mb_password = response.mb_password;
                    $this.data.mb_name = response.mb_name;
                    $this.data.mb_email = response.mb_email;
                    $this.data.mb_sex = response.mb_sex;
                    $this.data.mb_birth = response.mb_birth;
                    $this.data.mb_tel = response.mb_tel;
                    $this.data.mb_staff_name = response.mb_staff_name;
                    $this.data.mb_staff_tel = response.mb_staff_tel;
                    $this.data.mb_staff_email = response.mb_staff_email;
                    $this.data.mb_business_type = response.mb_business_type;
                    $this.data.mb_business_number = response.mb_business_number;
                    $this.data.mb_testing_experience = response.mb_testing_experience;
                    $this.data.mb_it_certificate = response.mb_it_certificate;

                    $this.data.mb_tester_type = response.mb_tester_type;
                    $this.data.expert_request_status = response.expert_request_status;

                    $this.startTime.time = response.mb_birth;

                    $this.data.address.data.postcode = response.mb_zip1 + "-" + response.mb_zip2;
                    $this.data.address.data.zonecode = response.mb_zip1 + response.mb_zip2;
                    $this.data.address.data.postcode1 = response.mb_zip1;
                    $this.data.address.data.postcode2 = response.mb_zip2;
                    $this.data.address.data.sido = response.mb_addr1;
                    $this.data.address.data.sigungu = response.mb_addr2;
                    $this.data.address.data.bname = response.mb_addr3;
                    $this.data.address.data.jibunAddress = response.mb_addr_jibeon;
                    $this.data.address.data.roadAddress = response.mb_addr_road;
                    $this.data.address.extraAddress = response.mb_addr_extra;
                })
            },
            validateBeforeSubmit() {
                var $this = this;

                this.$validator.validateAll().then((result) => {
                    if (result) {

                        if ($this.mode == "create") {

                            $.ajax({
                                method: "POST",
                                url: "/auth/signup",
                                data: {
                                    user: $this.user
                                }
                            })
                            .done((response) => {
                                $this.$emit('success');
                            })
                            .fail((response) => {
                                $this.$emit('error');
                            })

                        } else if ($this.mode == "modify") {

                            $.ajax({
                                method: "POST",
                                url: "/user/" + $this.user.mb_no,
                                data: {
                                    _method: 'put',
                                    user: $this.user
                                }
                            })
                            .done((response) => {
                                $this.$emit('success');

                                this.alert.body = '정보가 수정되었습니다.';
                                this.alert.is_open = true;
                            })
                            .fail((response) => {
                                $this.$emit('error');
                            })

                        }



                        return true;

                    }

                    $this.$emit('error');
                });
            },
            requestExpertTest() {

                if( ! confirm("전문테스터 신청을 접수하시겠습니까?")) {
                    return false;
                }

                $.ajax({
                    url: "/tester/" + this.user_id + "/request_expert_tester",
                    method: "get",
                }).done((response) => {
                    if (response.error == "") {
                        this.data.expert_request_status = "pending"
                    }
                })

            },
            withdrawalFromSite() {
                if (confirm('탈퇴하시겠습니까?')) {
                    window.location.href = "/user/" + this.user_id + "/withdrawal";
                }
            },
            birthdayBefore() {
                return moment().subtract(19, 'years').format('Y-MM-DD');
            }
        }

    }


</script>

<style lang="scss">

    .btn-submit {
        margin-top: 2em;
    }

    .form-group.has-error.has-feedback {
        .cov-datepicker {
            padding-right: 42.5px;
            border-color: #a94442;
            -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
            box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
        }
    }
    .cov-vue-date {
        display: block !important;
        .datepickbox {
            .cov-datepicker {
                display: block;
                width: 100%;
                height: 34px;
                padding: 6px 12px;
                padding-right: 12px;
                font-size: 14px;
                line-height: 1.42857143;
                color: #555;
                background-color: #fff;
                background-image: none;
                border: 1px solid #ccc !important;
                border-top-color: rgb(204, 204, 204);
                border-right-color: rgb(204, 204, 204);
                border-bottom-color: rgb(204, 204, 204);
                border-left-color: rgb(204, 204, 204);
                border-radius: 4px;
                -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
                box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
                -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
                -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
                transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/User.vue